<form data-testid="notifications">
    <form-section [subtitle]="subtitle(5014)">
        <form-card-button [subtitle]="subtitle(65)"
                          (onClick)="openUpdateDialog('error')">
            <notification-info [timeText]="getAlarmText('error')"
                               [isActive]="notificationConfig.error.enable"
                               (toggleSwitch)="toggleNotification('error')">
            </notification-info>
        </form-card-button>
        <form-card-button [subtitle]="subtitle(1063)"
                          (onClick)="openUpdateDialog('warning')">
            <notification-info [timeText]="getAlarmText('warning')"
                               [isActive]="notificationConfig.warning.enable"
                               (toggleSwitch)="toggleNotification('warning')">
            </notification-info>
        </form-card-button>
        <form-card-button [subtitle]="subtitle(3463)"
                          (onClick)="openUpdateDialog('info')">
            <notification-info [timeText]="getAlarmText('info')"
                               [isActive]="notificationConfig.info.enable"
                               (toggleSwitch)="toggleNotification('info')">
            </notification-info>
        </form-card-button>
    </form-section>
    <form-section [subtitle]="subtitle(1639)">
        <form-value-button [subtitle]="subtitle(3391)"
                           [value]="settings.selectedModule.email"
                           (onClick)="openDialog('changeEmail')">
        </form-value-button>
    </form-section>
    @if (settingsNotifications.allPushDevices !== null) {
        <form-section [subtitle]="subtitle(5223) + ' PUSH'">
            @for (device of settingsNotifications.allPushDevices; track device.id) {
                <form-item>
                    <form-label [label]="device.nazwa_urzadzenia"></form-label>
                    <form-button [subtitle]="subtitle(2880)"
                                 (click)="showAlertDeleteDevice(device)">
                    </form-button>
                </form-item>
            }
            @if (deviceName !== '' && deviceName !== undefined && deviceName !== null) {
                <form-item>
                    <form-label [label]="deviceName"></form-label>
                    <form-button [subtitle]="subtitle(1109)"
                                 (click)="settingsNotifications.addNotificationDevice()">
                    </form-button>
                </form-item>
            }
        </form-section>
        @if (settingsNotifications.assignedAccounts !== null && settingsNotifications.assignedAccounts.length) {
            <form-section [subtitle]="subtitle(6824) + ': ' + deviceName">
                @for (account of settingsNotifications.assignedAccounts; track account.id) {
                    <form-item>
                        <form-label [label]="account.name"></form-label>
                        <form-button [subtitle]="subtitle(2880)"
                                     (click)="showAlertRemoveAssignedAccount(account.id, account.name)">
                        </form-button>
                    </form-item>
                }
            </form-section>
        }
    }
</form>

@switch (settingsNotifications.showNotificationDialog) {
    @case ('alarm') {
        <app-dialog [subtitle]="subtitle(5014)" (close)="closeDialog()">
            <notification-time (close)="closeDialog()"
                               [isTurnedOnByToggleBtn]="isTurnedOnByToggleBtn"
                               [notificationType]="'error'">
            </notification-time>
        </app-dialog>
    }
    @case ('warning') {
        <app-dialog [subtitle]="subtitle(5014)" (close)="closeDialog()">
            <notification-time (close)="closeDialog()"
                               [isTurnedOnByToggleBtn]="isTurnedOnByToggleBtn"
                               [notificationType]="'warning'">
            </notification-time>
        </app-dialog>
    }
    @case ('notification') {
        <app-dialog [subtitle]="subtitle(5014)" (close)="closeDialog()">
            <notification-time (close)="closeDialog()"
                               [isTurnedOnByToggleBtn]="isTurnedOnByToggleBtn"
                               [notificationType]="'info'">
            </notification-time>
        </app-dialog>
    }
    @case ('changeEmail') {
        <app-dialog [subtitle]="subtitle(1639)" (close)="closeDialog()">
            <notification-email (close)="closeDialog()"></notification-email>
        </app-dialog>
    }
}
